import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';
import { Page } from '../types/page';
import {
  BulkCreateCreditLimitOfferDto,
  BulkCreateFailure,
  BulkSuccessDto,
  CreditLimitOffer,
  CreditLimitOfferDto,
  CreditLimitOfferHistory,
  CreditLimitOfferStatusDto,
} from '../types/credit-limit-offer';
import { SearchOptionsDTO } from '../types/search-options';

@Injectable({ providedIn: 'root' })
export class CreditLimitOfferService {
  constructor(private request: RequestService) { }

  getCreditLimitOfferList$(options?: SearchOptionsDTO): Observable<Page<CreditLimitOffer>> {
    return this.request.get(['credit-limit-offers'], { params: options });
  }

  getCreditLimitOfferById$(id: number): Observable<CreditLimitOffer> {
    return this.request.get(['credit-limit-offers', id]);
  }

  getCreditLimitOffersByClientId$(clientId: number): Observable<CreditLimitOffer[]> {
    return this.request.get(['credit-limit-offers', 'users', clientId]);
  }

  getActiveCreditLimitOfferByClientId$(clientId: number): Observable<CreditLimitOffer> {
    return this.request.get(['credit-limit-offers', 'users', clientId, 'active']);
  }

  getCreditLimitOfferHistoryByClientId$(clientId: number): Observable<CreditLimitOfferHistory[]> {
    return this.request.get(['credit-limit-offers', 'users', clientId, 'history']);
  }

  getCreditLimitOfferStatusByCreditId$(creditId: number): Observable<CreditLimitOfferStatusDto> {
    return this.request.get(['credit-limit-offers', 'credits', creditId]);
  }

  getAvailableAmount$(id: number): Observable<number> {
    return this.request.get(['credit-limit-offers', id, 'available-amount']);
  }

  createCreditLimitOffer$(
    offer: CreditLimitOfferDto,
  ): Observable<CreditLimitOffer> {
    return this.request.post(['credit-limit-offers'], {
      body: offer
    });
  }

  cancelCreditLimitOffer$(
    id: number,
  ): Observable<CreditLimitOffer> {
    return this.request.post(['credit-limit-offers', id, 'cancel']);
  }

  createBulkCreditLimitOffers$(
    bulkRequest: BulkCreateCreditLimitOfferDto,
  ): Observable<{ success: BulkSuccessDto[], errors: BulkCreateFailure[] }> {
    return this.request.post(['credit-limit-offers', 'bulk'], {
      body: bulkRequest
    });
  }
}